import Vue from 'vue'
import Vuex from 'vuex'

import auth from '@/store/auth'
import user from '@/store/user'
import shop from '@/store/shop'
import shopLineOA from '@/store/shop-lineoa'

Vue.use(Vuex)

const modules = {
  Auth: auth,
  User: user,
  Shop: shop,
  shopLineOA: shopLineOA,
}

export default new Vuex.Store({
  modules,
})
